import { useState } from 'react'
import toast from 'react-hot-toast'
import { getAuth } from 'firebase/auth'
import Button from './ui/Button'
import Card from './ui/Card'
import { FiArrowLeft, FiCheck, FiX } from 'react-icons/fi'
import { apiUrl } from '../config/api'

const DeviceRequirementModal = ({ onClose, onConfirmed, onNoDevice }) => {
  const [loading, setLoading] = useState(false)

  const handleConfirmHasDevice = async () => {
    setLoading(true)
    try {
      const auth = getAuth()
      const currentUser = auth.currentUser
      if (!currentUser) throw new Error('Faça login novamente.')
      const token = await currentUser.getIdToken()

      const resp = await fetch(apiUrl('/api/device/claim'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })

      const raw = await resp.text()
      const data = (() => {
        try { return JSON.parse(raw) } catch { return null }
      })()

      if (!resp.ok || !data?.ok) throw new Error(data?.error || 'Erro ao confirmar dispositivo.')

      toast.success('Dispositivo confirmado. Agora você pode assinar.')
      onConfirmed?.()
    } catch (err) {
      console.error(err)
      toast.error(err.message || 'Erro ao confirmar.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 z-[130] flex items-center justify-center p-3 sm:p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" aria-hidden="true" onClick={onClose} />

      <div className="relative w-full max-w-md min-w-0">
        <Card padding="lg" className="relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label="Fechar"
          >
            <FiX className="w-5 h-5 text-gray-700 dark:text-gray-300" />
          </button>

          <div className="mb-4 pt-2">
            <p className="text-xs font-bold text-accent uppercase tracking-[0.2em] mb-2">Antes de assinar</p>
            <h2 className="text-lg sm:text-xl font-extrabold text-gray-900 dark:text-white mb-1">
              Você já possui um dispositivo?
            </h2>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Para liberar o plano, precisamos confirmar que você tem o dispositivo SysMV.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-3">
            <Button
              type="button"
              variant="primary"
              size="lg"
              className="w-full gap-2"
              disabled={loading}
              onClick={handleConfirmHasDevice}
            >
              <FiCheck className="w-5 h-5" />
              Sim, tenho dispositivo
            </Button>
            <Button
              type="button"
              variant="secondary"
              size="lg"
              className="w-full gap-2"
              disabled={loading}
              onClick={() => {
                onClose()
                onNoDevice?.()
              }}
            >
              <FiArrowLeft className="w-5 h-5" />
              Não tenho — ver produtos
            </Button>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default DeviceRequirementModal

